var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsubweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_27176)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#A855F7",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 32C22.9979 32 24.2131 30.769 24.2131 29.25H18.787C18.787 30.769 20.0021 32 21.5 32ZM30.6348 25.5672C29.8155 24.6751 28.2823 23.3332 28.2823 18.9375C28.2823 15.5988 25.9718 12.9262 22.8563 12.2705V11.375C22.8563 10.6157 22.249 10 21.5 10C20.751 10 20.1437 10.6157 20.1437 11.375V12.2705C17.0282 12.9262 14.7177 15.5988 14.7177 18.9375C14.7177 23.3332 13.1846 24.6751 12.3652 25.5672C12.1107 25.8443 11.9979 26.1756 12 26.5C12.0047 27.2047 12.5505 27.875 13.3614 27.875H29.6386C30.4495 27.875 30.9957 27.2047 31 26.5C31.0021 26.1756 30.8893 25.8439 30.6348 25.5672Z",
    fill: "#8B5CF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_27176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsubweb);
export default __webpack_public_path__ + "static/media/newsubweb.d7f107998053d15d1aeac32e2a7a8acf.svg";
export { ForwardRef as ReactComponent };